import { action } from 'satcheljs';

export const preloadTimePanelData = action('PRE_LOAD_TIME_PANEL_DATA');
